import Parseable from '@/models/Parseable';

export default class ContactPerson extends Parseable {

    public id!: string;
    public name!: string;
    public email?: string | null;
    public phone?: string | null;
    public position?: string | null;
    public customer!: string;
    public active!: boolean;
    public leftAt?: number | null;

    public static parseFromObject(object: Partial<ContactPerson> | string): ContactPerson {
        const person = new ContactPerson();
        if (typeof object === 'string') {
            person.name = object;
            person.active = true;
            return person;
        }
        Object.assign(person, object);
        if (person.active == null) {
            person.active = true;
        }
        return person;
    }

    public static parseFromArray(array: Array<Partial<ContactPerson> | string> | undefined | null): ContactPerson[] {
        if (!Array.isArray(array)) {
            return [];
        }
        return array.map((item) => ContactPerson.parseFromObject(item));
    }

    parseToObject(): any {
        return { ...this };
    }
}

export function contactPersonId(person?: ContactPerson | string | null): string {
    if (!person) {
        return '';
    }
    if (typeof person === 'string') {
        return person;
    }
    return person.id || '';
}

export function contactPersonName(person?: ContactPerson | string | null): string {
    if (!person) {
        return '';
    }
    if (typeof person === 'string') {
        return person;
    }
    return person.name || '';
}

export function contactPersonLabel(person?: ContactPerson | string | null): string {
    const name = contactPersonName(person);
    if (!name) {
        return '';
    }
    if (person && typeof person === 'object' && person.active === false) {
        return `${name} (ausgeschieden)`;
    }
    return name;
}
